import './styles/app.css';
import Flow from './components/Flow';
import Header from './components/Header';
import SidePanel from './components/panel/SidePanel';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SelectedNodeProvider } from './context/SelectedNodeContext';
import { NodeDataProvider } from './context/NodeDataContext';
import { EdgesProvider } from './context/EdgesContext';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <div className="app">
        <NodeDataProvider>
          <EdgesProvider>
            <SelectedNodeProvider>
              <Header />
              <div className="flow-container">
                <DndProvider backend={HTML5Backend}>
                  <Flow />
                  <SidePanel />
                </DndProvider>
              </div>
            </SelectedNodeProvider>
          </EdgesProvider>
          <Toaster reverseOrder={false} />
        </NodeDataProvider>
    </div>
  );
}

export default App;
